import React from 'react';
import { Col, FormGroup, FormText, Label } from 'reactstrap';
import { Field } from 'redux-form';
import Brick from './BrickCore';
import i18n from '../../locales/i18n';
import { TranslatableWysiwygField } from '../../components';

class WaitApprovalBrick extends Brick {
    run(context, isEmbedded, onDone) {
        onDone(context);
        return (
            <div className="alert alert-info">
                {i18n.t('workflows.waiting_for_approval')}
            </div>
        );
    }

    getOptionsForm(_props) {
        const { t } = _props;
        return (
            <FormGroup row>
                <Label sm={12}>{t('workflows.bricks.wait.approval.options.message')}</Label>
                <Col sm={12}>
                    <Field
                        name={`bricks[${this.position}].options.message`}
                        component={TranslatableWysiwygField}
                    />
                    <FormText color="muted">
                        {t('workflows.bricks.wait.approval.options.message_help')}
                    </FormText>
                </Col>
            </FormGroup>
        );
    }
}

export default WaitApprovalBrick;
